<template>
  <div class="new-product body">
    <el-container>
      <!-- <CustomersAside /> -->

      <el-main>
        <el-card>
          <template slot="header">
            اضافة عميل جديد
          </template>
          <el-form :rules="rules" ref="NewCustomer" :model="form" label-width="120px" label-position="top">
            <el-row :gutter="10">
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="نوع الحساب" prop="type">
                  <!-- :filterable="true" -->
                  <el-select
                    id="input1"
                    @change="focusNext()"
                    class="input1"
                    v-model="form.type"
                    clearable
                    placeholder=" نوع الحساب"
                    style="width:100%"
                  >
                    <el-option label="عميل" value="1"> </el-option>
                    <el-option label=" عميل و مورد" value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-form-item label="نوع التسعير" prop="price_type">
                  <!-- :filterable="true" -->
                  <el-select
                    id="input2"
                    @change="focusNext()"
                    class="input2"
                    v-model="form.price_type"
                    clearable
                    placeholder="نوع التسعير"
                    style="width:100%"
                  >
                    <el-option label="جملة" value="2"> </el-option>
                    <el-option label="جملة الجملة" value="1"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="10" :lg="10" :md="24" :sm="24">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input3"
                    @focus="$event.target.select()"
                    v-model="form.name"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-form-item label="رصيد العميل" prop="account">
                  <el-input
                    class="input4"
                    id="account"
                    type="number"
                    @focus="$event.target.select()"
                    v-model="form.account"
                    controls-position="right"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
                <!-- <div class="searchForm">
                  <label for="search"> </label>
                </div> -->
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12" v-if="form.type == 2">
                <el-form-item label="رصيد المورد" prop="supplier_account">
                  <el-input
                    :class="form.type == 2 ? 'input5' : ''"
                    id="supplier_account"
                    @focus="$event.target.select()"
                    v-model="form.supplier_account"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
                <!-- <div class="searchForm">
                  <label for="search"> </label>

                </div> -->
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="رقم الهاتف 1" prop="phone">
                  <el-input
                    :class="form.type == 1 ? 'input5' : 'input6'"
                    id="phone"
                    @focus="$event.target.select()"
                    v-model="form.phone"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
                <!-- <div class="searchForm">
                  <label for="search"> </label>
                </div> -->
              </el-col>
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="رقم الهاتف 2 " prop="shop_phone">
                  <el-input
                    :class="form.type == 1 ? 'input6' : 'input7'"
                    id="phone"
                    @focus="$event.target.select()"
                    v-model="form.shop_phone"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
                <!-- <div class="searchForm">
                  <label for="search"> </label>
                </div> -->
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="العنوان" prop="address">
                  <el-input
                    :class="form.type == 1 ? 'input7' : 'input8'"
                    id="address"
                    @focus="$event.target.select()"
                    v-model="form.address"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
                <!-- <div class="searchForm">
                  <label for="search">  </label>
                </div> -->
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <!-- <br /> -->
                <el-button class="mt-5" type="warning" @click="addNewCustomer()">
                  تسجيل</el-button
                >
              </el-col>
            </el-row>
          </el-form>
          <!-- <div >
          </div> -->
          <!-- <div class="mt-3">
          </div> -->
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCustomer",
  // components: { CustomersAside },
  data() {
    return {
      index: 1,
      false: false,
      form: {
        name: "",
        type: "1",
        price_type:"1",
        inventory_id: 1,
        area: 1,
        phone: "",
        shop_phone: "",
        account: 0,
        supplier_account: 0,
        address: "-",
        },
      rules: {
        type: [
          { required: true, message:'حدد نوع حساب العميل', trigger: 'blur' },
        ],
        name: [
          { required: true, message:'حدد اسم العميل', trigger: 'blur' },
        ],
        account: [
          { required: true, message:'حدد الرصيد الافتتاحي', trigger: 'blur' },
        ],
        price_type: [
          { required: true, message:'حدد سياسة التسعير ', trigger: 'blur' },
        ],
        address: [
          { required: true, message:'حدد العنوان ', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'حدد رقم الهاتف', trigger: 'blur' },
          { min: 11, max: 11, message: 'حدد رقم هاتف صحيح', trigger: 'change' }
        ],
        shop_phone: [
          { min: 1, max: 11, message: 'حدد رقم هاتف صحيح', trigger: 'change' }
        ],
      },
    };
  },
  created() {},
  mounted() {},

  methods: {
    log(){
      console.log("blur");
    },
    focusNext() {
      if (this.form.type == 1 && this.index < 5) {
        this.index += 1;
      } else if (this.form.type == 2 && this.index < 6) {
        this.index += 1;
      } else {
        this.index = 1;
      }
      let input = ".input" + this.index + " input";
      console.log(input);
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },

    addNewCustomer() {
      this.$refs['NewCustomer'].validate((valid) => {
        if (valid) {
          axiosApi
            .post("customers", this.form)
            .then(() => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });
              setTimeout(() => {
                location.reload();
              }, 500);
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا رقم الهاتف مستخدم في حساب اخر ",
                type: "error",
                duration: 1500,
              });
            });
        }
      });
    },
  },
};
</script>